import { type MCPServerInfo } from '../../types';

const PerplexityAskServer: MCPServerInfo = {
  serverId: 'PERPLEXITY_ASK',
  name: 'Perplexity Ask',
  slug: 'perplexity-ask',
  description: 'Perplexity MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl:
      'https://github.com/ppl-ai/modelcontextprotocol/tree/main/perplexity-ask',
    commitSha: '332deaf',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['apiUrl', 'apiKey'],
    properties: {
      apiUrl: {
        type: 'string',
        description: 'The base URL for the Perplexity API.',
        sensitive: false,
        default: 'https://api.perplexity.ai/sonar'
      },
      apiKey: {
        type: 'string',
        description: 'The API key for Perplexity.',
        sensitive: true
      }
    }
  }
};

export default PerplexityAskServer;
